var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admin-instance-page sip-view-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm sip-view-head" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c(
          "div",
          { staticClass: "nk-block-head-content admin-instance-page__intro" },
          [
            _c(
              "router-link",
              {
                staticClass:
                  "admin-instance-page__back admin-instance-page__back--pill",
                attrs: {
                  to: "/instance",
                  title: _vm.trans("instance.instance"),
                  "aria-label": _vm.trans("instance.instance"),
                },
              },
              [
                _c("admin-icon", {
                  attrs: { name: "chevron-left", "aria-hidden": "true" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "admin-instance-page__intro-text" }, [
              _c("h3", { staticClass: "nk-block-title page-title mb-0" }, [
                _vm._v(_vm._s(_vm.trans("instance.instance"))),
              ]),
              _vm._v(" "),
              _vm.instance.domain || _vm.instance.email
                ? _c(
                    "div",
                    {
                      staticClass:
                        "nk-block-des text-soft admin-instance-page__intro-meta",
                    },
                    [
                      _vm.instance.domain
                        ? _c(
                            "span",
                            { staticClass: "admin-instance-page__domain" },
                            [_vm._v(_vm._s(_vm.instance.domain))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.instance.domain && _vm.instance.email
                        ? _c(
                            "span",
                            { staticClass: "admin-instance-page__dot" },
                            [_vm._v("·")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.instance.email
                        ? _c("span", [_vm._v(_vm._s(_vm.instance.email))])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row admin-instance-page__grid" }, [
      _c("div", { staticClass: "col-12 col-xl-5" }, [
        _c(
          "div",
          { staticClass: "card sip-view-card admin-instance-hero-card" },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "sip-view-status" }, [
                _c(
                  "span",
                  {
                    staticClass: "admin-status-badge",
                    class: "admin-status-badge--" + _vm.instanceStatusTone,
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.trans("instance." + _vm.instanceStatusNormalized)
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.instance.is_trial
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "admin-status-badge admin-status-badge--warning",
                      },
                      [_vm._v(_vm._s(_vm.trans("subscription.trial")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.instanceStatusNormalized !== "pending"
                  ? _c("span", { staticClass: "sip-view-status__meta" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.trans("subscription.till")) +
                          " " +
                          _vm._s(
                            _vm._f("moment")(_vm.instance.date_of_expiry)
                          ) +
                          "\n                        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("dl", { staticClass: "sip-view-dl admin-instance-meta" }, [
                _c("div", { staticClass: "admin-instance-meta__row" }, [
                  _c("dt", [_vm._v(_vm._s(_vm.trans("instance.email")))]),
                  _vm._v(" "),
                  _c("dd", [_vm._v(_vm._s(_vm.instance.email))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "admin-instance-meta__row" }, [
                  _c("dt", [_vm._v(_vm._s(_vm.trans("instance.domain")))]),
                  _vm._v(" "),
                  _c("dd", [
                    _c("code", { staticClass: "admin-instance-meta__code" }, [
                      _vm._v(_vm._s(_vm.instance.domain)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "admin-instance-meta__row" }, [
                  _c("dt", [
                    _vm._v(_vm._s(_vm.trans("instance.custom_domain"))),
                  ]),
                  _vm._v(" "),
                  _c("dd", [_vm._v(_vm._s(_vm.instance.custom_domain || "—"))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "admin-instance-meta__row" }, [
                  _c("dt", [_vm._v(_vm._s(_vm.trans("user.name")))]),
                  _vm._v(" "),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.instance.first_name + " " + _vm.instance.last_name
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "admin-instance-meta__row" }, [
                  _c("dt", [_vm._v(_vm._s(_vm.trans("plan.plan")))]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    [
                      _vm.instance.plan
                        ? [_vm._v(_vm._s(_vm.instance.plan.name))]
                        : _vm._e(),
                      _c(
                        "span",
                        { staticClass: "admin-instance-meta__price" },
                        [_vm._v(_vm._s(_vm.getPrice))]
                      ),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "admin-instance-meta__row" }, [
                  _c("dt", [_vm._v(_vm._s(_vm.trans("instance.created_at")))]),
                  _vm._v(" "),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm._f("momentDateTime")(_vm.instance.created_at))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "admin-instance-meta__row admin-instance-meta__row--last",
                  },
                  [
                    _c("dt", [
                      _vm._v(_vm._s(_vm.trans("instance.updated_at"))),
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm._f("momentDateTime")(_vm.instance.updated_at)
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.instanceStatusNormalized !== "pending" &&
        _vm.hasPermission("edit-instance")
          ? _c(
              "div",
              { staticClass: "card sip-view-card admin-instance-form-card" },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "admin-instance-card-head" }, [
                    _c(
                      "h4",
                      { staticClass: "admin-instance-card-head__title" },
                      [_vm._v(_vm._s(_vm.trans("user.force_change_password")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.updatePassword.apply(null, arguments)
                        },
                        keydown: function ($event) {
                          return _vm.updatePasswordForm.errors.clear(
                            $event.target.name
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.trans("auth.new_password"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.updatePasswordForm.new_password,
                                expression: "updatePasswordForm.new_password",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "password", name: "new_password" },
                            domProps: {
                              value: _vm.updatePasswordForm.new_password,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.updatePasswordForm,
                                  "new_password",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.updatePasswordForm,
                              "prop-name": "new_password",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.trans("auth.new_password_confirmation")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.updatePasswordForm
                                    .new_password_confirmation,
                                expression:
                                  "updatePasswordForm.new_password_confirmation",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "password",
                              name: "new_password_confirmation",
                            },
                            domProps: {
                              value:
                                _vm.updatePasswordForm
                                  .new_password_confirmation,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.updatePasswordForm,
                                  "new_password_confirmation",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.updatePasswordForm,
                              "prop-name": "new_password_confirmation",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "admin-instance-form-actions" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                              attrs: { type: "submit" },
                            },
                            [_vm._v(_vm._s(_vm.trans("general.save")))]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-xl-7" }, [
        _vm.instanceStatusNormalized !== "pending" &&
        _vm.hasPermission("edit-instance")
          ? _c(
              "div",
              { staticClass: "card sip-view-card admin-instance-form-card" },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "admin-instance-card-head" }, [
                    _c(
                      "h4",
                      { staticClass: "admin-instance-card-head__title" },
                      [_vm._v(_vm._s(_vm.trans("instance.update")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.update.apply(null, arguments)
                        },
                        keydown: function ($event) {
                          return _vm.updateInstanceForm.errors.clear(
                            $event.target.name
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.trans("instance.status"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.updateInstanceForm.status,
                                      expression: "updateInstanceForm.status",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { name: "status" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.updateInstanceForm,
                                        "status",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "running" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.trans("instance.running"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "expired" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.trans("instance.expired"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "suspended" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.trans("instance.suspended"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "terminated" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.trans("instance.terminated"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.updateInstanceForm,
                                  "prop-name": "status",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.trans("subscription.validity"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("datepicker", {
                                attrs: {
                                  bootstrapStyling: true,
                                  name: "date_of_expiry",
                                },
                                on: {
                                  selected: function ($event) {
                                    return _vm.updateInstanceForm.errors.clear(
                                      "date_of_expiry"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.updateInstanceForm.date_of_expiry,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.updateInstanceForm,
                                      "date_of_expiry",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "updateInstanceForm.date_of_expiry",
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.updateInstanceForm,
                                  "prop-name": "date_of_expiry",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.trans("instance.custom_domain"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.updateInstanceForm.custom_domain,
                                    expression:
                                      "updateInstanceForm.custom_domain",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", name: "custom_domain" },
                                domProps: {
                                  value: _vm.updateInstanceForm.custom_domain,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.updateInstanceForm,
                                      "custom_domain",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.updateInstanceForm,
                                  "prop-name": "custom_domain",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.trans("instance.max_student"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.updateInstanceForm.max_student,
                                    expression:
                                      "updateInstanceForm.max_student",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", name: "max_student" },
                                domProps: {
                                  value: _vm.updateInstanceForm.max_student,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.updateInstanceForm,
                                      "max_student",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.updateInstanceForm,
                                  "prop-name": "max_student",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 form-group" },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.trans("instance.remarks"))),
                              ]),
                              _vm._v(" "),
                              _c("autosize-textarea", {
                                attrs: {
                                  rows: "2",
                                  name: "remarks",
                                  placeholder: _vm.trans("instance.remarks"),
                                },
                                model: {
                                  value: _vm.updateInstanceForm.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.updateInstanceForm,
                                      "remarks",
                                      $$v
                                    )
                                  },
                                  expression: "updateInstanceForm.remarks",
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.updateInstanceForm,
                                  "prop-name": "remarks",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 form-group admin-instance-toggle-row",
                            },
                            [
                              _c("label", { staticClass: "mb-0" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans(
                                      "configuration.single_instance_maintenance_mode"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("switches", {
                                attrs: {
                                  name: "maintenance_mode",
                                  theme: "bootstrap",
                                  color: "success",
                                },
                                model: {
                                  value:
                                    _vm.updateInstanceForm.maintenance_mode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.updateInstanceForm,
                                      "maintenance_mode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "updateInstanceForm.maintenance_mode",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.updateInstanceForm.maintenance_mode
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "col-12 form-group" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans(
                                            "configuration.instance_maintenance_mode_message"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("autosize-textarea", {
                                      attrs: {
                                        rows: "2",
                                        name: "maintenance_mode_message",
                                        placeholder: _vm.trans(
                                          "configuration.instance_maintenance_mode_message"
                                        ),
                                      },
                                      model: {
                                        value:
                                          _vm.updateInstanceForm
                                            .maintenance_mode_message,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.updateInstanceForm,
                                            "maintenance_mode_message",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "updateInstanceForm.maintenance_mode_message",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.updateInstanceForm,
                                        "prop-name": "maintenance_mode_message",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-12 form-group" },
                                  [
                                    _c(
                                      "label",
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.trans(
                                              "configuration.instance_maintenance_exclude_ip"
                                            )
                                          ) + " "
                                        ),
                                        _c("show-tip", {
                                          attrs: {
                                            module: "configuration",
                                            tip: "tip_instance_maintenance_exclude_ip",
                                            type: "field",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("autosize-textarea", {
                                      attrs: {
                                        rows: "2",
                                        name: "exclude_ip_from_maintenance",
                                        placeholder: _vm.trans(
                                          "configuration.instance_maintenance_exclude_ip"
                                        ),
                                      },
                                      model: {
                                        value:
                                          _vm.updateInstanceForm
                                            .exclude_ip_from_maintenance,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.updateInstanceForm,
                                            "exclude_ip_from_maintenance",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "updateInstanceForm.exclude_ip_from_maintenance",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.updateInstanceForm,
                                        "prop-name":
                                          "exclude_ip_from_maintenance",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "admin-instance-form-actions" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                              attrs: { type: "submit" },
                            },
                            [_vm._v(_vm._s(_vm.trans("general.save")))]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 admin-instance-page__subscriptions" }, [
        _c("div", { staticClass: "admin-instance-section-bar" }, [
          _c("div", [
            _c("h4", { staticClass: "admin-instance-section-bar__title" }, [
              _vm._v(_vm._s(_vm.trans("subscription.subscription"))),
            ]),
            _vm._v(" "),
            _vm.subscriptions.total
              ? _c("p", { staticClass: "admin-instance-section-bar__meta" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.trans("general.total_result_found", {
                          count: _vm.subscriptions.total,
                        })
                      ) +
                      "\n                    "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm.subscriptions.total
          ? _c("div", { staticClass: "admin-list-table-card mb-4" }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c(
                  "table",
                  {
                    staticClass:
                      "table admin-data-table admin-data-table--config-list mb-0",
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.date"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.amount"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.plan"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.method"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.validity"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.status"))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.subscriptions.data, function (subscription) {
                        return _c("tr", { key: subscription.id }, [
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm._f("moment")(subscription.created_at))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.formatCurrency(
                                  subscription.amount,
                                  subscription.currency
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              textContent: _vm._s(subscription.plan.name),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              textContent: _vm._s(
                                subscription.method === "paypal"
                                  ? "Paypal"
                                  : "Credit Card"
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm._f("moment")(subscription.validity))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            subscription.status
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "admin-status-badge admin-status-badge--success",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.trans("subscription.complete"))
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "admin-status-badge admin-status-badge--danger",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.trans("subscription.failed"))
                                    ),
                                  ]
                                ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "admin-table-pagination-wrap" },
                [
                  _c("pagination-record", {
                    attrs: {
                      "page-length": _vm.filterSubscriptionForm.page_length,
                      records: _vm.subscriptions,
                    },
                    on: {
                      "update:pageLength": function ($event) {
                        return _vm.$set(
                          _vm.filterSubscriptionForm,
                          "page_length",
                          $event
                        )
                      },
                      "update:page-length": function ($event) {
                        return _vm.$set(
                          _vm.filterSubscriptionForm,
                          "page_length",
                          $event
                        )
                      },
                      updateRecords: _vm.getSubscriptions,
                    },
                    nativeOn: {
                      change: function ($event) {
                        return _vm.getSubscriptions.apply(null, arguments)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.subscriptions.total
          ? _c(
              "div",
              {
                staticClass: "admin-list-table-card admin-empty-state mb-4",
                attrs: { role: "status" },
              },
              [
                _c("div", { staticClass: "admin-empty-state__inner" }, [
                  _c(
                    "div",
                    {
                      staticClass: "admin-empty-state__icon-wrap",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "receipt" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "admin-empty-state__title" }, [
                    _vm._v(_vm._s(_vm.trans("subscription.module_info_title"))),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "admin-empty-state__text" }, [
                    _vm._v(
                      _vm._s(_vm.trans("subscription.module_info_description"))
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "card sip-view-card admin-instance-form-card admin-instance-form-card--subscription",
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "admin-instance-card-head" }, [
                _c("h4", { staticClass: "admin-instance-card-head__title" }, [
                  _vm._v(_vm._s(_vm.trans("subscription.add_new"))),
                ]),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "sip-view-note" }, [
                _vm._v(_vm._s(_vm.trans("subscription.add_new_tip"))),
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.addNewSubscription.apply(null, arguments)
                    },
                    keydown: function ($event) {
                      return _vm.subscriptionForm.errors.clear(
                        $event.target.name
                      )
                    },
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6 form-group" },
                      [
                        _c("label", [_vm._v(_vm._s(_vm.trans("plan.plan")))]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.subscriptionForm.plan_id,
                                expression: "subscriptionForm.plan_id",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "plan_id" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.subscriptionForm,
                                  "plan_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.trans("general.select_one"))),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.plans, function (plan) {
                              return _c(
                                "option",
                                { key: plan.id, domProps: { value: plan.id } },
                                [_vm._v(_vm._s(plan.name))]
                              )
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.subscriptionForm,
                            "prop-name": "plan_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6 form-group" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.trans("plan.payment_frequency"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.subscriptionForm.frequency,
                                expression: "subscriptionForm.frequency",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "frequency" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.subscriptionForm,
                                  "frequency",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.trans("general.select_one"))),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.payment_frequencies,
                              function (frequency) {
                                return _c(
                                  "option",
                                  {
                                    key: frequency.id,
                                    domProps: { value: frequency.id },
                                  },
                                  [_vm._v(_vm._s(frequency.name))]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.subscriptionForm,
                            "prop-name": "frequency",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6 form-group" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.trans("currency.currency"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.subscriptionForm.currency_id,
                                expression: "subscriptionForm.currency_id",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "currency_id" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.subscriptionForm,
                                  "currency_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.trans("general.select_one"))),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.currencies, function (currency) {
                              return _c(
                                "option",
                                {
                                  key: currency.id,
                                  domProps: { value: currency.id },
                                },
                                [_vm._v(_vm._s(currency.name))]
                              )
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.subscriptionForm,
                            "prop-name": "currency_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6 form-group" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.trans("subscription.amount"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.subscriptionForm.amount,
                              expression: "subscriptionForm.amount",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "amount",
                            placeholder: _vm.trans("subscription.amount"),
                          },
                          domProps: { value: _vm.subscriptionForm.amount },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.subscriptionForm,
                                "amount",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.subscriptionForm,
                            "prop-name": "amount",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6 form-group" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.trans("subscription.validity"))),
                        ]),
                        _vm._v(" "),
                        _c("datepicker", {
                          attrs: {
                            bootstrapStyling: true,
                            name: "date_of_expiry",
                          },
                          on: {
                            selected: function ($event) {
                              return _vm.subscriptionForm.errors.clear(
                                "date_of_expiry"
                              )
                            },
                          },
                          model: {
                            value: _vm.subscriptionForm.date_of_expiry,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.subscriptionForm,
                                "date_of_expiry",
                                $$v
                              )
                            },
                            expression: "subscriptionForm.date_of_expiry",
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.subscriptionForm,
                            "prop-name": "date_of_expiry",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6 form-group" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.trans("subscription.payment_method"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.subscriptionForm.payment_method,
                              expression: "subscriptionForm.payment_method",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "payment_method",
                            placeholder: _vm.trans(
                              "subscription.payment_method"
                            ),
                          },
                          domProps: {
                            value: _vm.subscriptionForm.payment_method,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.subscriptionForm,
                                "payment_method",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.subscriptionForm,
                            "prop-name": "payment_method",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6 form-group" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.trans("subscription.reference_number"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.subscriptionForm.reference_number,
                              expression: "subscriptionForm.reference_number",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "reference_number",
                            placeholder: _vm.trans(
                              "subscription.reference_number"
                            ),
                          },
                          domProps: {
                            value: _vm.subscriptionForm.reference_number,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.subscriptionForm,
                                "reference_number",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.subscriptionForm,
                            "prop-name": "reference_number",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 form-group" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.trans("instance.remarks"))),
                        ]),
                        _vm._v(" "),
                        _c("autosize-textarea", {
                          attrs: {
                            rows: "2",
                            name: "remarks",
                            placeholder: _vm.trans("instance.remarks"),
                          },
                          model: {
                            value: _vm.subscriptionForm.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.subscriptionForm, "remarks", $$v)
                            },
                            expression: "subscriptionForm.remarks",
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.subscriptionForm,
                            "prop-name": "remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "admin-instance-form-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                        attrs: { type: "submit" },
                      },
                      [_vm._v(_vm._s(_vm.trans("general.save")))]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }